import classNames from 'classnames';
import React, { useRef, useState, useEffect } from 'react';
import styles from './style.module.scss';
import { BudgetIcon, CalendarIcon, CrossIcon, DelIcon, DetailIcon, EditIcon, PencilIcon, PlusIcon, ProjectManagerIcon, ProjectNameIcon, StatusCheckIcon, TickIcon, managerAvatar } from 'assets';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { tableHeading, tableData, options, optionsConfigure } from './Constant';
import GenericTable from 'shared/components/common/table/table';
import Heading from 'shared/components/common/heading/Heading';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import AddCategory from 'shared/modal/add_category/AddCategory';
import { DeleteCategoryMutation, GetAllCategoryQuery } from 'shared/services/category_service/CategoryService';
import OverlayLoading from 'shared/screen_loader/overlay_loader/OverlayLoading';
import DeleteConfirmation from 'shared/modal/delete_confirmation/DeleteConfirmation';
import { isRestrictActions } from 'shared/utils/Helper';
import { screenActionEnum, screenEnum } from 'shared/utils/Enum';
import SearchBar from 'shared/components/common/searchbar/SearchBar';

export default function ManageCategory() {
    const { isLoading: DelLoading, mutate: DelMutate, isSuccess } = DeleteCategoryMutation();
    const {
        theme: { theme }
    } = useSelector((state) => state.root);
    const navigate = useNavigate();
    const [milestoneOption, setMileStoneOption] = useState(false);
    const [openProduct, setOpenProduct] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [openDelConfirm, setOpenDelConfirm] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const toggleEditUser = () => {
        setIsEdit(!isEdit);
    };
    const closeProductHandler = () => setOpenProduct(false);
    const closeDelConfirmation = () => setOpenDelConfirm(false);

    const [searchMenu, setsearchMenu] = useState('');
    const [clicksearch, setClickSearch] = useState('')
    const [searchResults, setSearchResults] = useState([]);
    const obj = {}
    if (clicksearch) {
        obj['search'] = clicksearch
    }
    const allTaskQueryParams = new URLSearchParams(obj).toString();
    const { isLoading, data, isError, error } = GetAllCategoryQuery(allTaskQueryParams);



    const SearchBars = () => {
        if (searchMenu.length > 0) {
            const filteredData = data.filter((user) => user.name.toLowerCase().includes(searchMenu.toLowerCase()));
            setSearchResults(filteredData);
        }
    }


    const [editCategoryData, setEditCategoryData] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);

    const handleEditCategory = (cat) => {
        setEditCategoryData(cat);
        setIsEditMode(true);
        setOpenProduct(true);
    };

    const handleCloseCategoryModal = () => {
        setOpenProduct(false);
        setEditCategoryData(null);
        setIsEditMode(false);
    };

    const columns = React.useMemo(
        () => [
            {
                Header: (
                    <div className={classNames(`${theme}FontColor w-100`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Category
                    </div>
                ),
                accessor: 'category',
                Cell: ({ row }) => <div className="w-100"> {row.original.name}</div>
            },

            {
                Header: (
                    <div className={classNames(`${theme}FontColor w-100 text-end me-2`)}>
                        <StatusCheckIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Action
                    </div>
                ),
                accessor: 'status',
                Cell: ({ row }) => (
                    <div className="d-flex justify-content-end align-items-center">
                        <div className="mx-2">
                            <EditIcon
                                className="pointer"
                                onClick={() => {
                                    handleEditCategory(row.original);
                                }}
                            />
                        </div>
                        <div className="mx-2">
                            <DelIcon
                                className="pointer"
                                onClick={() => {
                                    if (isRestrictActions(screenEnum.product, screenActionEnum.delete)) {
                                        setOpenDelConfirm(true);
                                        setSelectedItem(row.original);
                                    }
                                }}
                            />
                        </div>
                    </div>
                )
            }
        ],

        [theme, milestoneOption]
    );
    useEffect(() => {
        if (isSuccess) {
            setSelectedItem(null);
            closeDelConfirmation();
        }
        if (data) {
            setSearchResults(data)
        }
    }, [isSuccess, data, searchMenu]);
    return (
        <div className={classNames(styles.UserContainer, 'text-start')}>
            <SearchBar
                searchKey="name"
                suggestionsSource={data}
                onSearchChange={setSearchResults} // ✅ REQUIRED!
            />
            <div className={styles.Header}>
                <Heading heading={'Manage Category'} headingStyle={styles.Heading} />
                <div className="d-flex">
                    <CustomButton
                        Icon={PlusIcon}
                        IconStyle={classNames('me-1', styles.IconStyle)}
                        text={'Category'}
                        submitHandle={() => {
                            if (isRestrictActions(screenEnum.product, screenActionEnum.create)) {
                                setEditCategoryData(null);
                                setIsEditMode(false);
                                setOpenProduct(true);
                            }
                        }}
                        containerStyle={classNames(styles.AddProduct)}
                    />
                </div>
            </div>
            <GenericTable columns={columns} data={searchResults || []} TDTextStyle={classNames(styles.TDTextStyle)} TableWrapperStyle={classNames(styles.Table)} />
            <AddCategory
                show={openProduct}
                datatable={data}
                isEdit={isEditMode}
                editData={editCategoryData}
                handleClose={handleCloseCategoryModal}
            />
            <DeleteConfirmation
                show={openDelConfirm}
                loading={DelLoading}
                ConfimationHeading="Delete Category"
                Desc={'Are you sure you want to delete the Category?'}
                DeleteHandler={() => {
                    DelMutate(selectedItem?._id);
                }}

                handleClose={closeDelConfirmation}
            />
            {isLoading && <OverlayLoading />}
        </div>
    );
}
